<template>
  <WidgetCard title="Upcoming website crawls" icon="clock-circle" :loading="loading" :error="error" :empty="emptyMessage">
    <CrawlScheduleList v-if="rows.length" :rows="rows" />
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import CrawlScheduleList from './CrawlScheduleList.vue';
  import DashboardService from '../../services/dashboard.service';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';

  export default {
    name: 'UpcomingCrawlsWidget',
    components: { WidgetCard, CrawlScheduleList },
    // Account-wide — crawl schedules carry no tags or plan types.
    mixins: [dashboardWidget],
    data() {
      return {
        rows: []
      };
    },
    computed: {
      emptyMessage() {
        return !this.loading && !this.error && !this.rows.length ? 'No upcoming crawls' : '';
      }
    },
    methods: {
      fetchResource() {
        return DashboardService.fetchUpcomingCrawls(10);
      },
      applyResult(rows) {
        this.rows = rows;
      }
    }
  };
</script>
